module.exports = __webpack_public_path__ + "static/media/live.3911a4d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/live.svg
// module id = 193
// module chunks = 0